import React from "react";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description CustomTitle
 * @param String trans: Text for the label (required)
 * @returns {JSX.Element}
 */

const CustomTitle = ({ children}) => {
    return <>
        <h1 className='title-section'>{children}</h1>
    </>
}

export default CustomTitle
